export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo15-93ee3809d07d8d139060769c3bbd66fb.jpg";